import React, { useEffect, useState } from "react";
import { Table, Spin, Modal, Button, Tooltip } from "antd";
import { Tabs, Tab } from "react-bootstrap";
import CatalogJewelryDataService from "../../services/catalog-jewelry.service";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import Eye_icon from "../../assets/images/icons/eye_icon.svg";
import Delete_iconbl from "../../assets/images/icons/delete_iconbl.svg";

const UploadHistory = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [dataUploadList, setDataUploadList] = useState([]);
  const [imageUploadList, setImageUploadList] = useState([]);
  const [diamondUploadList, setDiamondUploadList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("DataUpload");
  const [dealerId, setDealerId] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalPage, setTotalPage] = useState(0);
  const [loginUser, setLoginUser] = useState({});
  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [dealerMemberTypeName, setdealerMemberTypeName] = useState("");
  const [vendorStatusID, setVendorStatusID] = useState(0);
  const [isUploadedDataModal, setIsUploadedDataModal] = useState(false);
  const [uploadListDetial, setUploadListDetial] = useState([]);
  const [stuckFileJewelryList, setStuckFileJewelryList] = useState([]);
  const [deleteStuckModal, setDeleteStuckModal] = useState(false);
  const [selectedStuckRow, setSelectedStuckRow] = useState(null);
  const [deleteStuckLoading, setDeleteStuckLoading] = useState(false);

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.responseData) {
        setVendorStatusID(loginDetials?.responseData?.vendorStatusID || 0);
        if (location.state && location.state.key == "ImageUpload") {
          setSelectedTab("ImageUpload");
          handleGetImageUploadList(
            loginDetials.responseData.dealerId,
            pageNo,
            pageSize
          );
        } else {
          setDealerId(loginDetials.responseData.dealerId);
          setdealerMemberTypeName(
            loginDetials.responseData.dealerMemberTypeName
          );
          handleGetDataUploadList(
            loginDetials.responseData.dealerId,
            pageNo,
            pageSize
          );
          setLoginUser(loginDetials.responseData);
        }
      }
    }
  }, []);
  const handleTabsChange = (e) => {
    setSelectedTab(e);
    if (e === "DataUpload") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetDataUploadList(dealerId, 1, 10);
    }
    if (e === "ImageUpload") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetImageUploadList(dealerId, 1, 10);
    }
    if (e === "Diamond") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetDiamondUploadList(dealerId, 1, 10);
    }
    if (e === "StuckFileJewelry") {
      setPageNo(1);
      setPageSize(10);
      setTotalPage(0);
      handleGetStuckFileJewelryList(dealerId, 1, 10);
    }
  };
  const handleGetDataUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "Jewelry",
      };
      CatalogJewelryDataService.GetDataUploadList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setDataUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setDataUploadList([]);
              setTotalPage(0);
            }
          } else {
            setDataUploadList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetImageUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "JewelryImage",
      };
      CatalogJewelryDataService.GetImageUploadList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setImageUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setImageUploadList([]);
              setTotalPage(0);
            }
          } else {
            setImageUploadList([]);
            setTotalPage(0);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleGetDiamondUploadList = (id, no, size) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "",
      };
      CatalogJewelryDataService.GetDiamondUploadList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setDiamondUploadList(responseData[0]);
              setTotalPage(responseData[1].TotalRecords);
            } else {
              setDiamondUploadList([]);
              setTotalPage(0);
            }
          } else {
            setDiamondUploadList([]);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const handleGetStuckFileJewelryList = (id, no, size) => {
    try {
      setLoading(true);
      const inputData = {
        pageIndex: no,
        pageSize: size,
        DealerID: id.toString(),
        uploadType: "JewelryStuck",
      };
      CatalogJewelryDataService.GetStuckFileList(inputData)
        .then((response) => {
          const { message, responseData } = response.data;
          if (message === "Success" && responseData) {
            setStuckFileJewelryList(responseData);
          } else {
            setStuckFileJewelryList([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
  const handleOpenDeleteStuck = (row) => {
    setSelectedStuckRow(row);
    setDeleteStuckModal(true);
  };
  const handleCloseDeleteStuck = () => {
    setDeleteStuckModal(false);
    setSelectedStuckRow(null);
  };
  const handleDeleteStuckFile = () => {
    if (!selectedStuckRow) return;
    try {
      const inputData = {
        dealerID: dealerId.toString(),
        summaryID: selectedStuckRow.summaryID,
        type: "jewelry",
      };
      setDeleteStuckLoading(true);
      CatalogJewelryDataService.DeleteStuckFile(inputData)
        .then((response) => {
          const message = response.data.message;
          const returnMessage = response.data.responseData?.returnMessage;
          setDeleteStuckLoading(false);
          if (message === "Success") {
            NotificationManager.success(
              t(returnMessage || "Deleted Successfully")
            );
            handleCloseDeleteStuck();
            handleGetStuckFileJewelryList(dealerId, 1, 10);
          } else {
            NotificationManager.error(t("Something went wrong"));
          }
        })
        .catch((error) => {
          console.log(error);
          setDeleteStuckLoading(false);
        });
    } catch (error) {
      console.log(error);
      setDeleteStuckLoading(false);
    }
  };
  const handleDownloadReportSummary = (row, type) => {
    try {
      let inputData = {
        summaryId: row.summaryID,
        dealerId: row.dealerID,
        type: type,
      };
      setDownloadLoader(true);
      CatalogJewelryDataService.DownloadReportSummary(inputData)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var now = new Date();
          var dateStr = String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + now.getFullYear();
          var filename =
            loginUser.dealerCompany +
            "(" +
            loginUser.dealerId +
            ")" +
            row.summaryID +
            "_" +
            dateStr +
            ".csv";
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
          setDownloadLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setDownloadLoader(false);
        });
    } catch (error) {
      console.log(error);
      setDownloadLoader(false);
    }
  };
  const handleDownloadReport = (row, type) => {
    try {
      let inputData = {
        summaryId: row.summaryID,
        dealerId: row.dealerID,
        type: type,
      };
      setDownloadLoader(true);
      CatalogJewelryDataService.DownloadReport(inputData)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          var now2 = new Date();
          var dateStr2 = String(now2.getMonth() + 1).padStart(2, '0') + String(now2.getDate()).padStart(2, '0') + now2.getFullYear();
          var filename =
            loginUser.dealerCompany +
            "(" +
            loginUser.dealerId +
            ")" +
            row.summaryID +
            "_" +
            dateStr2 +
            ".csv";
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
          setDownloadLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setDownloadLoader(false);
        });
    } catch (error) {
      console.log(error);
      setDownloadLoader(false);
    }
  };

  const handleRefershUpload = () => {
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, pageNo, pageSize);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, pageNo, pageSize);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, pageNo, pageSize);
    }
  };
  const handlePageNoChange = (page, pageSize) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setPageNo(page);
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, page, pageSize);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, page, pageSize);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, page, pageSize);
    }
  };
  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    if (selectedTab === "DataUpload") {
      handleGetDataUploadList(dealerId, current, size);
    }
    if (selectedTab === "ImageUpload") {
      handleGetImageUploadList(dealerId, current, size);
    }
    if (selectedTab === "Diamond") {
      handleGetDiamondUploadList(dealerId, current, size);
    }
  };
  const handleDownload = (url, fileName) => {
    window.open(url, "_blank");
  };
  const handleUploadedDataModalOpen = (rowData) => {
    setIsUploadedDataModal(true);
    handleGetUploadListDetails(dealerId, pageNo, pageSize, rowData.summaryID);
  };
  const handleUploadedDataModalClose = () => {
    setIsUploadedDataModal(false);
  };
  const handleGetUploadListDetails = (id, no, size, uploadID) => {
    try {
      setLoading(true);
      let inputData = {
        pageIndex: no,
        pageSize: size,
        dealerId: id,
        uploadType: "Jewelry",
        JewerlryDataUploadID: uploadID,
      };
      CatalogJewelryDataService.GetDataUploadListDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData) {
              setUploadListDetial(responseData[0]);
            } else {
              setUploadListDetial([]);
            }
          } else {
            setUploadListDetial([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <React.Fragment>
      <div className="prodetail__section">
        {vendorStatusID == 3 ? (
          <>{t("Please Contact GemFind to get Access.")}</>
        ) : (
          <div className="form__fields">
            <div className="col-md-12">
              <div className="prod__maindiv data__maping">
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="workarea__heading mt-0 mb-3">
                      {" "}
                      {t("Upload History")}{" "}
                    </h4>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <Spin spinning={downloadLoader}>
                      <div className="prodesc__div">
                        <Tabs
                          id="uncontrolled-tab-example"
                          className="tab__div "
                          onSelect={(e) => {
                            handleTabsChange(e);
                          }}
                          activeKey={selectedTab}
                        >
                          <Tab eventKey="DataUpload" title={t("Data Upload")}>
                            <div className="tabs__content">
                              <Table
                                columns={[
                                  {
                                    title: t("Date"),
                                    dataIndex: "dateOnly",
                                    width: 100,
                                  },
                                  {
                                    title: t("Time"),
                                    dataIndex: "timeOnly",
                                    width: 100,
                                  },
                                  {
                                    title: t("File"),
                                    width: "320px",
                                    ellipsis: true,
                                    dataIndex: "fileName",
                                    width: 300,
                                    render: (item, row) => {
                                      return (
                                        <React.Fragment>
                                          {row.downloadLink == null ? (
                                            <Tooltip title={row.fileName}>
                                              <span
                                                className="text-truncate d-inline-block"
                                                style={{
                                                  maxWidth: "300px",
                                                }}
                                              >
                                                {row.fileName}
                                              </span>
                                            </Tooltip>
                                          ) : (
                                            <p className="linkText">
                                              <span
                                                onClick={() =>
                                                  handleDownload(
                                                    row.downloadLink,
                                                    row.fileName
                                                  )
                                                }
                                              >
                                                <Tooltip title={row.fileName}>
                                                  <span
                                                    className="text-truncate d-inline-block"
                                                    style={{
                                                      maxWidth: "300px",
                                                    }}
                                                  >
                                                    {row.fileName}
                                                  </span>
                                                </Tooltip>
                                              </span>
                                            </p>
                                          )}
                                        </React.Fragment>
                                      );
                                    },
                                  },
                                  {
                                    title: t("Type"),
                                    dataIndex: "type",
                                    width: 120,
                                  },
                                  {
                                    title: t("Status"),
                                    dataIndex: "status",
                                    width: 100,
                                  },
                                  {
                                    title: t("Records"),
                                    dataIndex: "records",
                                    width: 100,
                                  },
                                  {
                                    title: t("Report"),
                                    dataIndex: "report",
                                    width: 100,
                                    render: (item, row) => {
                                      return (
                                        <React.Fragment>
                                          {row.status != "Completed" ? (
                                            t("InProcess")
                                          ) : (
                                            <a
                                              href="#"
                                              onClick={() => {
                                                handleDownloadReportSummary(
                                                  row,
                                                  "Jewelry"
                                                );
                                              }}
                                            >
                                              {t("Download")}
                                            </a>
                                          )}
                                        </React.Fragment>
                                      );
                                    },
                                  },
                                  {
                                    title: t("Action"),
                                    ellipsis: true,
                                    width: "50px",
                                    dataIndex: "action",
                                    width: 50,
                                    render: (index, row) => (
                                      <div className="action__btns">
                                        {row.showdetails === "true" && (
                                          <div className="image__block">
                                            <img
                                              src={Eye_icon}
                                              alt="img"
                                              onClick={() =>
                                                handleUploadedDataModalOpen(row)
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>
                                    ),
                                  },
                                ]}
                                dataSource={dataUploadList}
                                loading={loading}
                                scroll={{ x: 600, y: 800 }}
                                pagination={{
                                  current: pageNo,
                                  pageSize: pageSize,
                                  pageSizeOptions: [10, 20, 50, 100],
                                  responsive: true,
                                  showSizeChanger: true,
                                  total: totalPage,
                                  onChange: handlePageNoChange,
                                  onShowSizeChange: handlePageSizeChange,
                                }}
                              />
                            </div>
                          </Tab>
                          <Tab eventKey="ImageUpload" title={t("Image Upload")}>
                            <Table
                              columns={[
                                {
                                  title: t("Date"),
                                  dataIndex: "dateOnly",
                                  width: 100,
                                },
                                {
                                  title: t("Time"),
                                  dataIndex: "timeOnly",
                                  width: 100,
                                },
                                {
                                  title: t("File"),
                                  width: "320px",
                                  ellipsis: true,
                                  dataIndex: "fileName",
                                  width: 300,
                                  render: (item, row) => {
                                    return (
                                      <React.Fragment>
                                        {row.downloadLink == null ? (
                                          <Tooltip title={row.fileName}>
                                            <span
                                              className="text-truncate d-inline-block"
                                              style={{
                                                maxWidth: "300px",
                                              }}
                                            >
                                              {row.fileName}
                                            </span>
                                          </Tooltip>
                                        ) : (
                                          <p className="linkText">
                                            <span
                                              onClick={() =>
                                                handleDownload(
                                                  row.downloadLink,
                                                  row.fileName
                                                )
                                              }
                                            >
                                              <Tooltip title={row.fileName}>
                                                <span
                                                  className="text-truncate d-inline-block"
                                                  style={{ maxWidth: "300px" }}
                                                >
                                                  {row.fileName}
                                                </span>
                                              </Tooltip>
                                            </span>
                                          </p>
                                        )}
                                      </React.Fragment>
                                    );
                                  },
                                },
                                {
                                  title: t("Status"),
                                  dataIndex: "status",
                                  width: 100,
                                },
                                {
                                  title: t("Records"),
                                  dataIndex: "records",
                                  width: 100,
                                },
                                {
                                  title: t("Report"),
                                  dataIndex: "report",
                                  width: 100,
                                  render: (item, row) => {
                                    return (
                                      <React.Fragment>
                                        {row.status != "Completed" ? (
                                          t("InProcess")
                                        ) : (
                                          <a
                                            href="#"
                                            onClick={() => {
                                              handleDownloadReportSummary(
                                                row,
                                                "Image"
                                              );
                                            }}
                                          >
                                            {t("Download")}
                                          </a>
                                        )}
                                      </React.Fragment>
                                    );
                                  },
                                },
                              ]}
                              dataSource={imageUploadList}
                              loading={loading}
                              scroll={{ x: 600, y: 800 }}
                              pagination={{
                                current: pageNo,
                                pageSize: pageSize,
                                pageSizeOptions: [10, 20, 50, 100],
                                responsive: true,
                                showSizeChanger: true,
                                total: totalPage,
                                onChange: handlePageNoChange,
                                onShowSizeChange: handlePageSizeChange,
                              }}
                            />
                          </Tab>
                          {dealerMemberTypeName == "VendorDiamond" ||
                          dealerMemberTypeName == "Retailer" ? (
                            <Tab eventKey="Diamond" title={t("Diamond Upload")}>
                              <Table
                                columns={[
                                  {
                                    title: t("Date"),
                                    dataIndex: "dateOnly",
                                    width: 100,
                                  },
                                  {
                                    title: t("Time"),
                                    dataIndex: "timeOnly",
                                    width: 100,
                                  },
                                  {
                                    title: t("File"),
                                    dataIndex: "fileName",
                                    width: 300,
                                    render: (item, row) => {
                                      return (
                                        <React.Fragment>
                                          {row.downloadLink == null ? (
                                            <span>{row.fileName}</span>
                                          ) : (
                                            <p className="linkText">
                                              <span
                                                onClick={() =>
                                                  handleDownload(
                                                    row.downloadLink,
                                                    row.fileName
                                                  )
                                                }
                                              >
                                                {" "}
                                                {row.fileName}
                                              </span>
                                            </p>
                                          )}
                                        </React.Fragment>
                                      );
                                    },
                                  },
                                  {
                                    title: t("Type"),
                                    dataIndex: "type",
                                    width: 100,
                                  },
                                  {
                                    title: t("Status"),
                                    dataIndex: "status",
                                    width: 100,
                                  },
                                  {
                                    title: t("Records"),
                                    dataIndex: "records",
                                    width: 100,
                                  },
                                  {
                                    title: t("Report"),
                                    dataIndex: "report",
                                    width: 100,
                                    render: (item, row) => {
                                      return (
                                        <React.Fragment>
                                          {row.status != "Completed" ? (
                                            t("InProcess")
                                          ) : (
                                            <a
                                              href="#"
                                              onClick={() => {
                                                handleDownloadReportSummary(
                                                  row,
                                                  "Diomond"
                                                );
                                              }}
                                            >
                                              {t("Download")}
                                            </a>
                                          )}
                                        </React.Fragment>
                                      );
                                    },
                                  },
                                ]}
                                dataSource={diamondUploadList}
                                loading={loading}
                                scroll={{ x: 600, y: 800 }}
                                pagination={{
                                  current: pageNo,
                                  pageSize: pageSize,
                                  pageSizeOptions: [10, 20, 50, 100],
                                  responsive: true,
                                  showSizeChanger: true,
                                  total: totalPage,
                                  onChange: handlePageNoChange,
                                  onShowSizeChange: handlePageSizeChange,
                                }}
                              />
                            </Tab>
                          ) : null}
                          <Tab
                            eventKey="StuckFileJewelry"
                            title={t("Stuck File")}
                          >
                            <Table
                              columns={[
                                {
                                  title: t("Date"),
                                  dataIndex: "dateOnly",
                                  width: 100,
                                },
                                {
                                  title: t("Time"),
                                  dataIndex: "timeOnly",
                                  width: 100,
                                },
                                {
                                  title: t("File Name"),
                                  dataIndex: "fileName",
                                  width: 300,
                                },
                                {
                                  title: t("Status"),
                                  dataIndex: "status",
                                  width: 150,
                                },
                                {
                                  title: t("Action"),
                                  dataIndex: "action",
                                  width: 100,
                                  render: (index, row) => (
                                    <div className="action__btns">
                                      <div className="image__block">
                                        <img
                                          src={Delete_iconbl}
                                          onClick={() =>
                                            handleOpenDeleteStuck(row)
                                          }
                                          alt=""
                                          style={{ cursor: "pointer" }}
                                        />
                                      </div>
                                    </div>
                                  ),
                                },
                              ]}
                              dataSource={stuckFileJewelryList}
                              loading={loading}
                              scroll={{ x: 600, y: 800 }}
                              pagination={false}
                            />
                          </Tab>
                        </Tabs>

                        {selectedTab !== "StuckFileJewelry" && (
                          <div className="col-md-6 mt-3">
                            <button
                              className="primary-btn"
                              onClick={handleRefershUpload}
                            >
                              {t("Update History")}
                            </button>
                          </div>
                        )}
                      </div>
                    </Spin>
                    {/* Delete stuck file confirmation modal */}
                    <Modal
                      className="datamapping__modal"
                      centered
                      visible={deleteStuckModal}
                      onOk={handleDeleteStuckFile}
                      onCancel={handleCloseDeleteStuck}
                      width={400}
                      footer={[
                        <Button key="back" onClick={handleCloseDeleteStuck}>
                          {t("Cancel")}
                        </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          loading={deleteStuckLoading}
                          onClick={handleDeleteStuckFile}
                        >
                          {t("Delete")}
                        </Button>,
                      ]}
                    >
                      <div className="col-lg-12">
                        <div className="modal__body">
                          <div className="col-lg-12">
                            <div className="form__fields border-0 p-0">
                              <div className="row">
                                <div className="col-lg-12 text-center">
                                  <p className="subheading">
                                    {t("Are you sure you want to delete")} ?
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal>
                    {/* Show uploaded data modal */}
                    <Modal
                      title={t("Upload History Details")}
                      visible={isUploadedDataModal}
                      className="upl_show_details"
                      onCancel={handleUploadedDataModalClose}
                      maskClosable={false}
                      footer={[
                        <div className="d-block">
                          <Button
                            className="primary-btn"
                            onClick={handleUploadedDataModalClose}
                          >
                            {t("Close")}
                          </Button>
                        </div>,
                      ]}
                    >
                      <div className="form__fields p-0 border-0 mh-auto upload_card">
                        <div>
                          <Table
                            columns={[
                              {
                                title: t("Date"),
                                dataIndex: "dateOnly",
                                width: 100,
                              },
                              {
                                title: t("Time"),
                                dataIndex: "timeOnly",
                                width: 100,
                              },
                              {
                                title: (
                                  <Tooltip title={t("File")}>
                                    {t("File")}
                                  </Tooltip>
                                ),
                                width: "320px",
                                ellipsis: true,
                                dataIndex: "fileName",
                                width: 180,
                                render: (item, row) => {
                                  return (
                                    <React.Fragment>
                                      {row.downloadLink == null ? (
                                        <Tooltip title={row.fileName}>
                                          <span
                                            className="text-truncate d-inline-block"
                                            style={{
                                              maxWidth: "300px",
                                            }}
                                          >
                                            {row.fileName}
                                          </span>
                                        </Tooltip>
                                      ) : (
                                        <p className="linkText">
                                          <span
                                            onClick={() =>
                                              handleDownload(
                                                row.downloadLink,
                                                row.fileName
                                              )
                                            }
                                          >
                                            <Tooltip title={row.fileName}>
                                              <span
                                                className="text-truncate d-inline-block"
                                                style={{ maxWidth: "300px" }}
                                              >
                                                {row.fileName}
                                              </span>
                                            </Tooltip>
                                          </span>
                                        </p>
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              },
                              {
                                title: t("Type"),
                                dataIndex: "type",
                                width: 120,
                              },
                              {
                                title: t("Status"),
                                dataIndex: "status",
                                width: 100,
                              },
                              {
                                title: t("Records"),
                                dataIndex: "records",
                                width: 100,
                              },
                              {
                                title: t("Action"),
                                dataIndex: "action",
                                width: 100,
                                render: (item, row) => {
                                  return (
                                    <React.Fragment>
                                      {row.status != "Completed" ? (
                                        t("InProcess")
                                      ) : (
                                        <a
                                          href="#"
                                          onClick={() => {
                                            handleDownloadReport(
                                              row,
                                              "Jewelry"
                                            );
                                          }}
                                        >
                                          {t("Download")}
                                        </a>
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              },
                            ]}
                            dataSource={uploadListDetial}
                            loading={loading}
                            pagination={false}
                            // scroll={{ x: 600, y: 800 }}
                          />
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default UploadHistory;
